import { ClassName, IFormRender } from "@busybusy/webapp-react-ui";
import { CertificationOptions } from "__generated__/graphql";
import classNames from "classnames";
import BasicPickerFormField from "components/foundation/form-fields/BasicPickerFormField/BasicPickerFormField";
import { IBasicPickerValue } from "components/foundation/pickers/basic-picker/BasicPicker/BasicPicker";
import { t } from "i18next";
import { v_require } from "utils/validations";

export interface ICertificationsFormFieldProps<T extends ICertificationsFormFieldData> {
  form: IFormRender<T>;
  className: ClassName;
}

export interface ICertificationsFormFieldData {
  certifications: CertificationOptions;
}

function CertificationsFormField<T extends ICertificationsFormFieldData>({ form, className }: ICertificationsFormFieldProps<T>) {
  const options: Array<IBasicPickerValue<CertificationOptions>> = [
    {
      id: CertificationOptions.ManageAll,
      name: t('Manage')
    },
    {
      id: CertificationOptions.ManageSelf,
      name: t('Self Only')
    },
    {
      id: CertificationOptions.ViewCrew,
      name: t('View Crew')
    }
  ];

  const classes = classNames('certifications-form-field', className);

  return (
    <div className={classes}>
      <BasicPickerFormField
        name="certifications"
        form={form}
        data={options}
        validations={[{ validation: v_require }]}
      />
    </div>
  )
}

export default CertificationsFormField;